var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "or-modal",
    {
      ref: "modal",
      attrs: {
        "is-open": _vm.isOpen,
        size: _vm.ModalSize.S,
        "data-component": "base-create-layout-popup",
      },
      on: {
        close: function ($event) {
          return _vm.$emit("cancel")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t("HITL.ui-customization.create-layout-popup.title")
                  ) +
                  "\n  "
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "base-create-layout-popup-content" },
        [
          _c("or-input", {
            attrs: {
              "data-input": "create-layout-popup-name",
              "model-value": _vm.values.name,
              label: _vm.$t(
                "HITL.ui-customization.create-layout-popup.layout-name-title"
              ),
              placeholder: _vm.$t(
                "HITL.ui-customization.create-layout-popup.layout-name-placeholder"
              ),
              error: _vm.nameErrorMessage,
            },
            on: {
              "update:modelValue": function ($event) {
                return _vm.onInput("name", $event)
              },
            },
          }),
          _vm._v(" "),
          _c("or-select", {
            attrs: {
              "data-select": "create-layout-popup-initial-component",
              "model-value": _vm.values.component,
              label: _vm.$t(
                "HITL.ui-customization.create-layout-popup.initial-component-title"
              ),
              placeholder: _vm.$t(
                "HITL.ui-customization.create-layout-popup.initial-component-placeholder"
              ),
              options: _vm.componentOptions,
              error: _vm.componentErrorMessage,
            },
            on: {
              "update:modelValue": function ($event) {
                return _vm.onInput("component", $event)
              },
            },
          }),
          _vm._v(" "),
          _c("or-textarea", {
            attrs: {
              "model-value": _vm.values.description,
              label: _vm.$t(
                "HITL.ui-customization.create-layout-popup.description-title"
              ),
              placeholder: _vm.$t(
                "HITL.ui-customization.create-layout-popup.description-placeholder"
              ),
            },
            on: {
              "update:modelValue": function ($event) {
                return _vm.onInput("description", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "base-create-layout-popup-footer" },
        [
          _c("or-checkbox", {
            attrs: {
              "data-checkbox": "create-layout-popup-is-default",
              "model-value": _vm.values.makeActive,
              label: _vm.$t(
                "HITL.ui-customization.create-layout-popup.make-default"
              ),
            },
            on: {
              "update:modelValue": function ($event) {
                return _vm.onInput("makeActive", $event)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "base-create-layout-popup-footer-actions" },
            [
              _c(
                "or-button",
                {
                  attrs: {
                    "data-button": "cancel-create-layout",
                    variant: _vm.ButtonVariant.Outlined,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("HITL.common.actions.cancel")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "or-button",
                {
                  attrs: { "data-button": "confirm-create-layout" },
                  on: { click: _vm.onCreate },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("HITL.common.actions.create")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }